import React from "react";

const Pages_contract = () => {
  return <div>Pages_contract</div>;
};

export default Pages_contract;
